export default {
    state: {
        permissions: {}
    },
    mutations: {
        SET_PERMISSIONS (state, permissions) {
            state.permissions = permissions
        }
    },
    actions: {
        setPermissions ({ commit }, data) {
            commit('SET_PERMISSIONS', data)
        }
    },
    getters: {
        getPermissions: (state) => state.permissions,
        isAllowed: (state) => (permission) => {
            return state.permissions?.[permission] !== 'N'
        }
    }
}
